import { Outlet, Navigate } from "react-router-dom";

const PrivateRoute = () => {
  return localStorage.token ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
